import './styles/TextBadge.scss';

import * as React from 'react';

import Text from 'components/Text';
import cx from 'classnames';

export type TextBadgeColor =
  | 'chalkboard'
  | 'apple'
  | 'atlas'
  | 'ruler'
  | 'paper'
  | 'graphite'
  | 'pencil'
  | 'coaching-orange-lightest';
export type TextBadgeTextColor = 'whiteout' | 'graphite' | 'chalkboard' | 'apple' | 'elmer';

type NonDefaultProps = {
  children: React.ReactNode;
  className?: string;
};

type DefaultProps = {
  color: TextBadgeColor;
  textSize: 'xsmall' | 'xxxxsmall';
  textColor: TextBadgeTextColor;
  textWeight: 'normal' | 'semibold';
};

export type Props = NonDefaultProps & DefaultProps;

class TextBadge extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    color: 'paper',
    textColor: 'graphite',
    textWeight: 'semibold',
    textSize: 'xsmall',
  };

  render() {
    const { color, textColor, textWeight, textSize, children, className } = this.props;

    return (
      <Text
        color={textColor}
        weight={textWeight}
        size={textSize}
        className={cx('TextBadge', `TextBadge--${color}`, `TextBadge--${textSize}`, className)}
        element="div">
        {children}
      </Text>
    );
  }
}

export default TextBadge;
